export const MessagesReducerInitialState = {
  conversationsByConversationSid: {},
};
